import { logger } from '@zep/core-logger';
import { useViewport } from '@/hooks';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { useOpenUserProfile } from '@/shared/hooks/useOpenUserProfile';
import { cn } from '@/utils/tailwind.util';
import { PublicQuizTooltip } from './PublicQuizTooltip';
interface AuthorTagProps {
  authorName: string;
  isOfficial?: boolean;
  authorHashId: string;
  iconSize?: 'xs' | 'sm';
  className?: string;
  /** 프로필로 가는 동작을 바꿀 때 넘긴다(예: 플레이 화면은 새 탭). 없으면 `useOpenUserProfile` 을 따른다. */
  onOpenProfile?: (authorHashId: string) => void;
}
export const AuthorTag = ({
  authorName,
  isOfficial = false,
  authorHashId,
  iconSize = 'sm',
  className,
  onOpenProfile
}: AuthorTagProps) => {
  const {
    isMobile
  } = useViewport();
  const openUserProfile = useOpenUserProfile();
  const isInExternalPlatform = useIsInExternalPlatform();
  const handleClick = (e: React.MouseEvent) => {
    if (isInExternalPlatform) return;
    e.preventDefault();
    e.stopPropagation();
    logger.track('click_user_profile');
    (onOpenProfile ?? openUserProfile)(authorHashId);
  };
  return <div className={cn('group/author inline-flex w-fit items-center gap-4xs', !isInExternalPlatform && 'cursor-pointer')} onClick={handleClick} data-sentry-component="AuthorTag" data-sentry-source-file="AuthorTag.tsx">
      <span className={cn('truncate text-center text-neutral text-body-md-medium', !isInExternalPlatform && 'group-hover/author:text-assistive', className)}>
        {authorName}
      </span>
      {isOfficial && !isInExternalPlatform && <PublicQuizTooltip triggerIconSize={iconSize} onClick={!isMobile ? handleClick : undefined} />}
    </div>;
};